import { setMeta } from '@/helpers/metaHelpers.js'

export const seo = {
  actions: {
    updateCategorySeo(context, category) {
      setMeta({
        description: category.tagline,
        image: category.image,
        title: category.title,
      })
    },
    updateActivitySeo(context, activity) {
      setMeta({
        description: activity.short_description,
        image: activity.image,
        title: activity.title,
      })
    },
  },
}
